export default __webpack_public_path__ + "static/media/28-min.9cd077b9.png";